"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAeMaterials = void 0;
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const availableMaterials = ['NC', 'ESD', 'HT', 'DT', 'EG+'];
const materials = {
    [echain_shared_igus_fundamentals_1.AppName.EIQ]: availableMaterials,
    // EKE it's not allowed to change the material for AE's
    [echain_shared_igus_fundamentals_1.AppName.EKE]: [],
    // EIC, ECF has no ae's
    [echain_shared_igus_fundamentals_1.AppName.EIC]: [],
    [echain_shared_igus_fundamentals_1.AppName.ECF]: [],
    [echain_shared_igus_fundamentals_1.AppName.TEST]: [],
};
const getAeMaterials = (appName) => {
    return (0, echain_shared_ts_utils_1.clonePrimitive)(materials[appName]);
};
exports.getAeMaterials = getAeMaterials;
//# sourceMappingURL=aeMaterials.js.map